<template>
  <div class="filter-local-tree-item">
    <div v-if="showIcons" class="icon-wrapper">
      <svgicon v-if="isAparelho || isGrupoDeLocal"
              class="filter-local-tree-item-icon"
              :icon="typeIcon"
              width="15"
              height="15"
              color="gray"></svgicon>
      <i v-else
        class="filter-local-tree-item-icon"
        :class="`mdi ${typeIcon} icon`"></i>
    </div>   

    <span>{{ node.label }}</span>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },

  props: {
    node: {
      type: Object,
    },
    showIcons: {
      type: Boolean,
      default: true
    }
  },

  watch: {},

  created() {},

  computed: {
    typeIcon() {
      let icon = "";

      if (this.isLocal) {
        icon = "mdi-map-marker-outline";
      } else if (this.isAparelho) {
        icon = "access-point";
      } else if (this.isEstabelecimento) {
        icon = "mdi-store";
      } else if (this.isGrupoDeLocal) {
        icon = "folder-marker-outline";
      }

      return icon;
    },
    isGrupoDeLocal() {
      return this.node.raw.type === 0;
    },
    isLocal() {
      return this.node.raw.type === 1;
    },
    isAparelho() {
      return this.node.raw.type === 3;
    },
    isEstabelecimento() {
      return this.node.raw.type === -1;
    },
  },

  methods: {},

  beforeDestroy() {},

  mixins: [],

  mounted() {},
};
</script>

<style lang="scss" scoped>
.filter-local-tree-item {
  display: flex;
  align-items: center;

  span {
    line-height: 20px;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;

    .filter-local-tree-item-icon {
    margin: 0 5px;
    color: gray;
    width: 15px;
  }
  }

 
}
</style>
